import { ValidatorFn } from '@angular/forms';
import { Option } from '../../../../../classes';

export function optionTextRequiredValidator (option:Option):ValidatorFn {
    return (): { [key: string]: boolean } => {
        if (!option.text) {
            return {
                option_text_required:true,
            }
        }
        return null;
    }    
}
